import { createContext, useContext } from "react";

export type UserRolesGGE = {
  СУПЕР: boolean;
  АДМИНИСТРИРОВАНИЕ: boolean;
  МОДЕРИРОВАНИЕ: boolean;
  ПРОСМОТР: boolean;
  НЕТ: boolean;
};

export const defaultUserRolesGGE: UserRolesGGE = {
  СУПЕР: false,
  АДМИНИСТРИРОВАНИЕ: false,
  МОДЕРИРОВАНИЕ: false,
  ПРОСМОТР: false,
  НЕТ: false,
};

export const RolesContext = createContext<UserRolesGGE>(defaultUserRolesGGE);

export const useUserRolesContext = () => useContext(RolesContext);
